import { render, staticRenderFns } from "./PagoProveedor.vue?vue&type=template&id=27f48bb5&scoped=true"
import script from "./PagoProveedor.vue?vue&type=script&lang=js"
export * from "./PagoProveedor.vue?vue&type=script&lang=js"
import style0 from "./PagoProveedor.vue?vue&type=style&index=0&id=27f48bb5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f48bb5",
  null
  
)

export default component.exports